import { SidePanelDS, ButtonDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const StatementsSummarySectionBadge = (props: { firstPath: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SidePanelDS.Section verticalSpacing={2} horizontalSpacing={1.5}>
      <ButtonDS
        text={t("badges.sidePanel.button.transactions")}
        format={"hug"}
        buttonType={"secondary"}
        onClick={() => navigate(`/${props.firstPath}/transactions/badges`)}
      />
    </SidePanelDS.Section>
  );
};
